import { Alert, FormErrorsType, Upload } from '@/components'
import { FormChangeEventHandler, JsonDataType } from '@/types'

export interface HomeImprovementContractUploadFormDataType extends JsonDataType {
    home_improvement_contract?: File
}

interface HomeImprovementContractUploadFormProps {
    form: HomeImprovementContractUploadFormDataType
    errors: FormErrorsType
    inputClassName: string
    onChange: FormChangeEventHandler
}

export const HomeImprovementContractUploadForm = ({
    form,
    errors,
    inputClassName,
    ...props
}: HomeImprovementContractUploadFormProps) => <>
    <Alert type="warning" className={inputClassName}>
        <h4 className="font-semibold text-warning-700">
            Important Notice: Late Warranty Enrollment Requirement
        </h4>
        <ul className="list-disc pl-6 mt-2">
            <li>
                This warranty enrollment was submitted outside the standard enrollment window. Solar Insure requires all
                warranties to be enrolled
                within <span className="font-semibold">120 days of the installation date.</span>
            </li>
            <li>
                To ensure compliance and confirm that the Solar Insure warranty was offered at the point of
                sale, <span className="font-semibold">we require</span> a copy of the fully
                executed <span className="font-semibold">Home Improvement Contract (HIC)</span>, including
                the <span className="font-semibold">Solar Insure addendum</span>.
            </li>
        </ul>
        <p className="mt-4">
            Please upload the necessary documentation to avoid delays in processing. If you have any questions, contact
            our support team.
        </p>
    </Alert>

    <Upload
        name="home_improvement_contract"
        value={form.home_improvement_contract}
        onChange={props.onChange}
        className={inputClassName}
        errors={errors.home_improvement_contract}
        accept="application/pdf"
    >
        <div className="mt-3 text-center">
            {form.home_improvement_contract
                ? <p className="text-sm">{form.home_improvement_contract.name}</p>
                : <>
                    <p className="text-sm">
                        <span className="text-orange-700">Click to upload</span> or drag and drop</p>
                    <p className="text-xs mt-1">PDF (max. 10mb)</p>
                </>}
        </div>
    </Upload>
</>
